// Fichier bqb-integration.js pour intégrer BQB
(function() {
  // Lorsque le DOM est prêt
  document.addEventListener('DOMContentLoaded', function() {
    
    // Fonction pour initialiser BQB avec le thème
    function initBQB() {
      // S'assurer que la fonction de mise à jour de quantité existe
      if (typeof window.bqb_updateQuantity !== 'function') {
        window.bqb_updateQuantity = function(newQuantity) {
          const quantityInput = document.getElementById('Quantity-buy_buttons');
          if (quantityInput) {
            quantityInput.value = newQuantity;
            
            // Mettre à jour tous les autres champs de quantité si nécessaire
            document.querySelectorAll('input[name="quantity"]').forEach(input => {
              if (input.id !== 'Quantity-buy_buttons') {
                input.value = newQuantity;
              }
            });
            
            // Publier un événement pour informer le thème du changement
            if (typeof window.PUB_SUB_EVENTS !== 'undefined' && typeof window.publish === 'function') {
              window.publish(window.PUB_SUB_EVENTS.quantityUpdate, undefined);
            }
          }
        };
      }
      
      // S'assurer que la fonction de mise à jour des plans de vente existe
      if (typeof window.bqb_initSellingPlans !== 'function') {
        window.bqb_initSellingPlans = function() {
          document.querySelectorAll('[action*="/cart/add"]').forEach((addToCartForm) => {
            if (!addToCartForm.querySelector('[name="selling_plan"]')) {
              var bqb_sellingPlanInput = document.createElement("input");
              bqb_sellingPlanInput.type = "hidden";
              bqb_sellingPlanInput.name = "selling_plan";
              bqb_sellingPlanInput.value = "";
              addToCartForm.appendChild(bqb_sellingPlanInput);
            }
          });
        };
        
        // Initialiser les plans de vente
        window.bqb_initSellingPlans();
      }
      
      // S'assurer que la fonction de mise à jour du plan de vente existe
      if (typeof window.bqb_updateSellingPlan !== 'function') {
        window.bqb_updateSellingPlan = function(newSellingPlan) {
          document.querySelectorAll('[action*="/cart/add"]').forEach((addToCartForm) => {
            let sellingPlanInput = addToCartForm.querySelector('[name="selling_plan"]');
            if (!sellingPlanInput) {
              sellingPlanInput = document.createElement("input");
              sellingPlanInput.type = "hidden";
              sellingPlanInput.name = "selling_plan";
              sellingPlanInput.value = "";
              addToCartForm.appendChild(sellingPlanInput);
            }
            sellingPlanInput.value = newSellingPlan;
          });
        };
      }
    }
    
    // Observer pour détecter les changements dans le DOM
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.classList && node.classList.contains('bqb-ui')) {
              // BQB UI a été ajouté au DOM
              initBQB();
            }
          }
        }
      });
    });
    
    // Observer le document entier
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Initialiser BQB si déjà présent
    if (document.querySelector('.bqb-ui')) {
      initBQB();
    }
  });
})();